import { hex2rgba } from '~/utils';
import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const ModalContainer: StyleRule = ({ theme }) => ({
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.overlay,
    backgroundColor: hex2rgba('#000', 0.45),
    justifyContent: 'center',
    alignItems: 'center',
});

export const ModalContentArea: StyleRule = () => ({
    margin: pxArrayToRem([176, 410]),
    minWidth: pxToRem(1100),
    minHeight: pxToRem(728),
    maxWidth: pxToRem(1100),
    maxHeight: pxToRem(728),
});

export const LeftColumn: StyleRule = ({ theme }) => ({
    background: theme.siteVariables.colors.white['FFF'],
});

export const RightColumn: StyleRule = () => ({
    background: '#f7f7f7',
});

export const ModalMotionContainer: StyleRule = ({ theme }) => ({
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.overlay,
    backgroundColor: hex2rgba('#000', 0.45),
    justifyContent: 'center',
});

export const ModalFlexContainer: StyleRule = () => ({
    padding: 0,
    borderTop: 'none',
    margin: 0,
});
